import { useEffect, useState } from "react";
import { Company } from "../types";

interface CompaniesApiResponse {
    success: boolean,
    data: Company[]
}

export default function useCompaniesAPI(jobScannerKey: string = '') {

    const [loading, setLoading] = useState(false)
    const [companies, setCompanies] = useState<Company[] | null>(null)

    async function fetchCompanies() {
        setLoading(true)

        const api_url = process.env.REACT_APP_API_SERVER_URL
        const api_version = process.env.REACT_APP_API_VERSION

        const res = await fetch(`${api_url}/api/${api_version}/companies/${jobScannerKey}`,
            {
                credentials: 'include',
            }
        )

        const apiResponse: CompaniesApiResponse = await res.json()
        const companyData = apiResponse.data

        setCompanies(Array.isArray(companyData) ? companyData : [companyData])
        setLoading(false)

    }

    useEffect(function () {

        (async () => {
            // console.log("Fetching companies...")
            await fetchCompanies()
        })()
    }, [])

    return { loading, companies }
}